export default "__VITE_ASSET__C23YQiKD__"